module.exports = __webpack_public_path__ + "img/success.96bc0a7d.gif";